import VolumeOffIcon from '@mui/icons-material/VolumeOff'
import VolumeUpIcon from '@mui/icons-material/VolumeUp'
import { Avatar, Box, IconButton, Stack, Typography } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { IReel } from '../types'
type Props = {
  reel: IReel | undefined
  play: boolean
  index: number
  onEnded?: () => void
}

export const VideoReel = ({ index, reel, play, onEnded }: Props) => {
  const [processTime, setProcessTime] = useState(0)
  const videoRefs = useRef<HTMLVideoElement | null>(null)
  useEffect(() => {
    if (videoRefs.current) {
      if (play) {
        videoRefs.current.play()
      } else {
        videoRefs.current.pause()
      }
    }
  }, [play])

  const handleMute = () => {
    if (videoRefs.current) {
      videoRefs.current.muted = !videoRefs.current.muted
    }
  }

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '8px',
        aspectRatio: '9/16',
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '12px',
          left: '12px',
          right: '12px',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: '0.4em',
          height: 'fit-content',
        }}
      >
        {/* progress bar video */}
        <Box className="block h-0.5 rounded-sm" sx={{ backgroundColor: 'white', opacity: 0.3 }}>
          <Box
            className="absolute left-0 top-0 h-0.5 rounded-sm"
            sx={{ backgroundColor: 'white', opacity: 1, width: `${processTime * 100}%` }}
          />
        </Box>
        {/* author vs mute butotn */}
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
          <Stack direction="row" spacing={1} alignItems="center">
            <Avatar src={reel?.author_avatar} sx={{ width: 32, height: 32 }} />
            <Typography variant="body2" sx={{ color: 'white', fontWeight: 600 }}>
              {reel?.author_name}
            </Typography>
          </Stack>
          <IconButton onClick={handleMute} sx={{ height: 32, width: 32, borderRadius: 16, color: 'white' }}>
            {videoRefs.current?.muted ? <VolumeOffIcon /> : <VolumeUpIcon />}
          </IconButton>
        </Stack>
      </Box>
      <video
        ref={videoRefs}
        poster={reel?.thumbnail}
        className="img-cover block"
        playsInline
        preload={'none'}
        onTimeUpdate={(e) => {
          //@ts-ignore
          setProcessTime(e.target.currentTime / e.target.duration)
        }}
        onEnded={onEnded}
      >
        <source src={reel?.video_reel_url} type="video/mp4" />
        <track src="/path/to/captions.vtt" kind="subtitles" srcLang="en" label="English" />
      </video>
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '50%',
          background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 100%)',
        }}
      ></Box>
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          padding: '0.5em',
          color: 'white',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.4em',
            fontSize: '0.875rem',
            fontWeight: 500,
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, color: 'white' }}
            dangerouslySetInnerHTML={{ __html: reel?.title || '' }}
          />
          <Typography
            variant="caption"
            noWrap
            sx={{
              fontWeight: 600,
              color: 'white',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
            dangerouslySetInnerHTML={{ __html: reel?.content || '' }}
          />
        </Box>
      </Box>
    </Box>
  )
}
